import * as React from 'react';

export type AppContextType = {
  setFullHeight: (value: boolean) => any,
}

export default React.createContext<AppContextType>(null);
